module.exports = __webpack_public_path__ + "static/health-coaches.ca5cd231.jpg";